export function initRoleFeatures() {
    document.querySelectorAll('[data-role-features]').forEach((section) => {
        const tabs = [...section.querySelectorAll('[data-role-feature-tab]')];
        const panels = [...section.querySelectorAll('[data-role-feature-panel]')];
        const progress = section.querySelector('[data-role-feature-progress]');
        if (!tabs.length) return;
        let active = Math.max(0, tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        let animation;
        const select = (index, focus = false) => {
            if (index < 0 || index >= tabs.length) return;
            animation?.cancel();
            active = index;
            tabs.forEach((tab, i) => {
                tab.setAttribute('aria-selected', String(i === active));
                tab.tabIndex = i === active ? 0 : -1;
                panels[i].hidden = i !== active;
            });
            progress.style.transform = `scaleY(${(active + 1) / tabs.length})`;
            if (focus) tabs[active].focus({ preventScroll: true });
            if (!reduced.matches) animation = panels[active].animate(
                [{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }],
                { duration: 300, easing: 'ease-in-out' }
            );
        };
        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => select(index));
            tab.addEventListener('keydown', (event) => {
                const rtl = getComputedStyle(section).direction === 'rtl';
                const next = event.key === 'ArrowDown' || event.key === (rtl ? 'ArrowLeft' : 'ArrowRight');
                const previous = event.key === 'ArrowUp' || event.key === (rtl ? 'ArrowRight' : 'ArrowLeft');
                let target;
                if (next) target = (active + 1) % tabs.length;
                if (previous) target = (active - 1 + tabs.length) % tabs.length;
                if (event.key === 'Home') target = 0;
                if (event.key === 'End') target = tabs.length - 1;
                if (target === undefined) return;
                event.preventDefault();
                select(target, true);
            });
        });
        let delta = 0;
        let lastEvent = 0;
        let lastChange = 0;
        section.querySelector('[data-role-feature-wheel]').addEventListener('wheel', (event) => {
            if (!window.matchMedia('(min-width: 1025px) and (hover: hover)').matches || event.ctrlKey || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
            const direction = Math.sign(event.deltaY);
            if (!direction || active + direction < 0 || active + direction >= tabs.length) return;
            event.preventDefault();
            const now = performance.now();
            if (now - lastEvent > 180 || Math.sign(delta) !== direction) delta = 0;
            lastEvent = now;
            if (now - lastChange < 400) return;
            delta += event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? window.innerHeight : 1);
            if (Math.abs(delta) < 55) return;
            select(active + direction);
            lastChange = now;
            delta = 0;
        }, { passive: false });
        progress.style.transform = `scaleY(${(active + 1) / tabs.length})`;
        reduced.addEventListener('change', () => { if (reduced.matches) animation?.cancel(); });
    });
}
